import React, { useState, useRef, useContext, useEffect } from 'react';
import { GetUserContext } from '../Context/GetUserContext';
import { LuMenu } from "react-icons/lu";
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../img/logo_new.png';
import './LeftMenu.css'
import Dropdown from 'react-bootstrap/Dropdown';

const LeftMenu = () => {
    const { size, myContext, setMyContext, setConjIdHome, sequenceMenus } = useContext(GetUserContext);
    const refIds = useRef([]);
    const [activeId, setActiveId] = useState(myContext);
    const [userLocal, setuserLocal] = useState({})
    let navigate = useNavigate();

    useEffect(() => {
        const getDataUser = JSON.parse(localStorage.getItem('user'))
        if (getDataUser) {
            setuserLocal(getDataUser?.Corporate_Name?.slice(0, 2))
        }

        setMyContext(parseInt(localStorage.getItem("page")))
        setActiveId(myContext)

    }, [])

    const [activeConjId, setActiveConjId] = useState(1);
    const [activeMenuLeft, setActiveMenuLeft] = useState(false);

    const handleConjClick = (id) => {
        setActiveConjId(id);
        setConjIdHome(id);
    };
    const handleCountMenuAndPage = (e) => {
        setMyContext(e)
    }
    const handleClick = (id) => {
        setActiveId(id);
        setActiveConjId(1);
        setConjIdHome(1);
        localStorage.setItem("page", id)
    };

    const handleMenuLeftActived = () => {
        setActiveMenuLeft(!activeMenuLeft)
    }

    useEffect(() => {
        const pageAtual = sequenceMenus.filter(item => item?.id === myContext)

        if (pageAtual?.[0]?.page != undefined) {
            navigate(`${pageAtual?.[0]?.page}`)
        }

    }, [sequenceMenus])

    const logout = () => {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('datasFinanc')

        const token = localStorage.getItem('token')
        const user = localStorage.getItem('user')
        const datasFinanc = localStorage.getItem('datasFinanc')

        if (token === null && user === null && datasFinanc === null) {
            return window.location.href = '/';
        }
    }

    useEffect(() => {
        if (size?.categoria === 'large') {
            setActiveMenuLeft(true)

        } else if (size?.categoria === 'xlarge') {
            setActiveMenuLeft(false)
        }
    }, [size?.categoria])

    return (
        size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
            (<div className='nav-bottom'>
                <div className='side-menu-small-mobile'>

                    {sequenceMenus.map((m, index) => (
                        <Link to={m.page} key={index}>
                            <div
                                className={` ${myContext === m.id ? 'icon-menu-active-mobile' : 'icon-menu-mobile'}`}
                                id={m.id}
                                ref={el => refIds.current[index] = el}
                                data-toggle="tooltip" title="Disabled tooltip"
                                onClick={() => {
                                    handleClick(m.id, index);
                                    handleCountMenuAndPage(m.id);
                                }}
                            >{m.icon}
                            </div>
                        </Link>
                    ))}

                </div>
            </div>)
            :
            (
                <div className={` ${activeMenuLeft === true ? 'left-menu-less' : 'left-menu'}`}>
                    <div className='side-menu-small'>
                        <div>
                            <div className='icon-menu-logo' onClick={handleMenuLeftActived}><LuMenu /></div>
                            {sequenceMenus.map((m, index) => (
                                <Link to={m.page} key={index}>
                                    <div
                                        className={` ${myContext === m.id ? 'icon-menu-active' : 'icon-menu'}`}
                                        id={m.id}
                                        ref={el => refIds.current[index] = el}
                                        data-toggle="tooltip" title="Disabled tooltip"
                                        onClick={() => {
                                            handleClick(m.id, index);
                                            handleCountMenuAndPage(m.id);
                                        }}
                                    >{m.icon} </div>
                                </Link>
                            ))}
                        </div>

                        <Dropdown drop="up" className=' dropdown-toggle-clear'>
                            <Dropdown.Toggle variant="black" id="dropdown-basic">
                                <div className='footer-left-menu text-secondary'> {`${userLocal}`}</div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={logout} >Sair</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>



                    </div>

                    {
                        activeMenuLeft ?
                            (<></>) :
                            (<>
                                <div className='side-menu-small-additional bg-white'>
                                    <div className='icon-menu-logo-img'><img src={Logo} /> </div>
                                    <div>
                                        {
                                            sequenceMenus
                                                .filter(menu => menu.id === myContext)
                                                .map(menu => (
                                                    <React.Fragment key={menu.id}>
                                                        <div className='title-menu-name'>{menu.name}</div>
                                                        {
                                                            menu?.conj && menu?.conj?.map((con) => (
                                                                <div key={con.id} onClick={() => handleConjClick(con.id)}>
                                                                    <div className={`conj-name ${activeConjId === con.id ? 'conj-name-active' : ''}`}>{con?.conjName}</div>
                                                                </div>
                                                            ))
                                                        }
                                                    </React.Fragment>
                                                ))
                                        }
                                    </div>
                                </div>
                            </>)
                    }

                </div>
            )


    )
}

export default LeftMenu